/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import {
	Notification,
	setSidebarVisibility,
	MenuItemLink,
	getResources,
	useLogout,
} from "react-admin";
import { useSelector, useDispatch } from "react-redux";
import {
	Typography,
	AppBar,
	Paper,
	Fab,
	IconButton,
	Dialog,
	DialogContent,
	DialogActions,
	Button,
	useMediaQuery,
	Drawer,
	Avatar,
	Popover,
	Badge,
	DialogContentText,
	LinearProgress,
	Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import Logo from "./images/logo.png";
import PSBLogo from './images/ps_business_logo.svg';
import { customTheme } from "./customTheme";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import DefaultIcon from "@material-ui/icons/ViewList";
import ExitIcon from "@material-ui/icons/PowerSettingsNew";
import SearchBar from "./components/SearchBar";
import config from "./config.json";
import { stringify } from "query-string";
import { useIdleTimer } from "react-idle-timer";
import SubMenu from "./components/SubMenu";
import ConfirmationNumberOutlinedIcon from "@material-ui/icons/ConfirmationNumberOutlined";
import PaymentIcon from "@material-ui/icons/Payment";
import MenuIcon from "@material-ui/icons/Menu";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import BrandingWatermarkOutlinedIcon from "@material-ui/icons/BrandingWatermarkOutlined";
import LogsDefaultIcon from "./images/logs-default.svg";
import LogsGreenIcon from "./images/logs-green.svg";
import UsersDefaultIcon from "./images/users-default.svg";
import UsersGreenIcon from "./images/users-green.svg";
import CompanyDefaultIcon from "./images/company-default.svg";
import CompanyGreenIcon from "./images/company-green.svg";
import PermitDefaultIcon from "./images/permit-default.svg";
import PhonelinkRingIcon from "@material-ui/icons/PhonelinkRing";
import InventoryIcon from "@material-ui/icons/Inbox";
import WarehouseIcon from "@material-ui/icons/Home";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import ContactMail from "@material-ui/icons/ContactMail";
import { CustomRouteHeader } from "./components/CustomRouteHeader";
import SdCardOutlinedIcon from "@material-ui/icons/SdCardOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import DeleteIcon from "@material-ui/icons/Delete";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import MenuBookIcon from '@material-ui/icons/MenuBook';
import LibraryBooksOutlinedIcon from "@material-ui/icons/LibraryBooksOutlined";
import PermDeviceInformationOutlinedIcon from "@material-ui/icons/PermDeviceInformationOutlined";
import PlaceOutlinedIcon from "@material-ui/icons/PlaceOutlined";
import LocalParkingIcon from "@material-ui/icons/LocalParking";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import BusinessIcon from "@material-ui/icons/Business";
import BookIcon from "@material-ui/icons/Book";
import BeenhereIcon from "@material-ui/icons/Beenhere";
import EmojiTransportationOutlinedIcon from "@material-ui/icons/EmojiTransportationOutlined";
import MapOutlinedIcon from "@material-ui/icons/MapOutlined";
import ApartmentOutlinedIcon from "@material-ui/icons/ApartmentOutlined";
//import CustomParkingSelectorPopOver from "./components/CustomParkingSelectorPopOver";
import facebook from "./images/facebook.png";
import twitterPng from "./images/twitter.png";
import instagramPng from "./images/instagram.png";
import linkedinPng from "./images/linkedin.png";
import UseAnalyticsEvent from "./utils/useAnalyticsEvent";
import notify from "./components/CustomUseNotify";
import AssessmentIcon from "@material-ui/icons/Assessment";
import DescriptionIcon from "@material-ui/icons/Description";
import { ContextProvider } from "./globalContextProvider";
import MovieFilterIcon from "@material-ui/icons/MovieFilter";
import { changeToAdminUser, changeToOldUser, changeUser, getTutorials } from "./sharedData";
import InfoIcon from "@mui/icons-material/Info"
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SearchIcon from '@material-ui/icons/Search';
import queryString from 'query-string';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import LogoutDialog from "./components/LogoutDialog";
import DemoIcon from "./images/DemoIconSVG.svg"
import TutorialSVF from "./images/TutorialSVG.svg"
import ContactUsActiveImg from './images/contact_us_active.svg'
import ContactUsInActiveImg from './images/contact_us_in_active.svg'
import Skeleton from '@material-ui/lab/Skeleton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useHistory } from "react-router-dom";

const appBarHeight = 60;
const sidebarOpenWidth = 256;
const sidebarClosedWidth = 83;
const regex = new RegExp("(/[0-9]+$)|(/[0-9]+/$)");
const resourceLabel = {
	"/rfidData": "Permit Users",
	"/permit/users": "Permit Users",
	"/permit/users/create": (
		<CustomRouteHeader
			pathUrl="/permit/users"
			createName="Create User"
			prevPathName="Permit Users"
		/>
	),
	"/permit/users/edit": (
		<CustomRouteHeader
			pathUrl="/rfidData"
			createName="Edit User"
			prevPathName="Permit User"
		/>
	),
	"/parkings": "Dashboard",
	"/permitLogs": "Permit Logs",
	"/permit/logs": "Permit Logs",
	"/monthlyPass": "Monthly Pass",
	"/monthlyPassRequest": "Monthly Pass Request",
	"/rfidOrganization": "Permit Company",
	"/permitOrganization": "Permit Company",
	"/operator/users": "Operator Users",
	"/operator/devices": "Operator Devices",
	"/operator/shifts": "Operator Shifts",
	"/operator/patrolling": "Operator Patrolling",
	"/appUpdateUrls": "App Version",
	"/rfidData/create": (
		<CustomRouteHeader
			pathUrl="/rfidData"
			createName="Create User"
			prevPathName="Permit Users"
		/>
	),
	"/rfidRequests": "Permit Requests",
	"/permitRequests": "Permit Requests",
	"/rfidPayments": "Permit Payments",
	"/permit/payments": "Permit Payments",
	"/parkingInfo": "Parking Details",
	"/crmUsers": "Dashboard Users",
	"/parkingControllers": "Controllers",
	"/controllerEdit": "Controllers Edit",
	"/parkingSlotBookings": "Slot Bookings",
	"/verifyVehicles": "Vehicles",
	"/parkingLeds": "Parking Leds",
	"/inventory": "Inventory Home",
	"/rfidInventory": "Inventory Tags",
	"/permitInventory": "Inventory Tags",
	"/operatorUsers": "Operator Users",
	"/operatorDevices": "Operator Devices",
	"/controllers": "Controllers Status",
	"/resources": "Resources",
	"/rfidOrganization/create": (
		<CustomRouteHeader
			pathUrl="/rfidOrganization"
			createName="Create RFID Company"
			prevPathName="Permit Company"
		/>
	),
	"/operator/users/create": (
		<CustomRouteHeader
			pathUrl="/operator/users"
			createName="Create Operator User"
			prevPathName="Operator User"
		/>
	),
	"/appUpdateUrls/create": (
		<CustomRouteHeader
			pathUrl="/appUpdateUrls"
			createName="Upload App Version"
			prevPathName="App Version"
		/>
	),
	"/crmUsers/create": (
		<CustomRouteHeader
			pathUrl="/crmUsers"
			createName="Create Dashboard User"
			prevPathName="Dashboard Users"
		/>
	),
	"/operatorDevices/create": (
		<CustomRouteHeader
			pathUrl="/operatorDevices"
			createName="Add Operator Device"
			prevPathName="Operator Devices"
		/>
	),
	"/operatorUsers/create": (
		<CustomRouteHeader
			pathUrl="/operatorUsers"
			createName="Create Operator Users"
			prevPathName="Operator Users"
		/>
	),
	"/parkings/create": (
		<CustomRouteHeader
			pathUrl="/parkings"
			createName="Create Parking"
			prevPathName="Dashboard"
		/>
	),
	"/rfidData/edit": (
		<CustomRouteHeader
			pathUrl="/rfidData"
			createName="Edit User"
			prevPathName="Permit User"
		/>
	),
	"/parkings/edit": (
		<CustomRouteHeader
			pathUrl="/parkings"
			createName="Edit Setting"
			prevPathName="Dashboard"
		/>
	),
	"/parkingLeds/edit": (
		<CustomRouteHeader
			pathUrl="/parkings"
			createName="Edit Setting"
			prevPathName="Parking"
		/>
	),
	"/operatorUsers/edit": (
		<CustomRouteHeader
			pathUrl="/operatorUsers"
			createName="Edit User"
			prevPathName="Edit Operator Users"
		/>
	),
	"/crmUsers/edit": (
		<CustomRouteHeader
			pathUrl="/crmUsers"
			createName="Edit Dashboard User"
			prevPathName="Dashboard Users"
		/>
	),
	"/rfidOrganization/edit": (
		<CustomRouteHeader
			pathUrl="/rfidOrganization"
			createName="Edit Company"
			prevPathName="Permit Company"
		/>
	),
	"/controllersEdit/edit": (
		<CustomRouteHeader
			pathUrl="/controllers"
			createName="Edit Controller"
			prevPathName="Controllers"
		/>
	),
	"/jammuUsers": "Users",
	"/deviceWallet": "Device Wallet",
	"/deviceWalletsTransactions": "Device Wallets Transactions",
	"/cardsInventory": "Cards Inventory",
	"/rfidApartments": "Apartments",
	"/permitApartments": "Apartments",
	"/rfidApartments/edit": (
		<CustomRouteHeader
			pathUrl="/rfidApartments"
			createName="Edit Apartments"
			prevPathName="Apartments"
		/>
	),
	"/allParkingsDetails": "All Parkings Logs",
	"/exemptedVehicles": "VIP Vehicles",
	"/exemptedVehicles/create": (
		<CustomRouteHeader
			pathUrl="/exemptedVehicles"
			createName="Create VIP Vehicle"
			prevPathName="VIP Vehicles"
		/>
	),
	"/exemptedVehicles/edit": (
		<CustomRouteHeader
			pathUrl="/exemptedVehicles"
			createName="Edit VIP Vehicle"
			prevPathName="VIP Vehicles"
		/>
	),
	"/scannedTagsDetails": "Visitor Logs",
	"/rfidsDeletedDetails": "Deleted",
	"/permitDeletedDetails": "Deleted",
	"/siteAudits": "Site Audits",
	"/warriorusers": "Warrior Users",
	"/operator/devices/create": (
		<CustomRouteHeader
			pathUrl="/operator/devices"
			createName="Create Operator Device"
			prevPathName="Operator Devices"
		/>
	),
	"/societiesparking": "Societies",
	"/societiesparking/create": (
		<CustomRouteHeader
			pathUrl="/societiesparking"
			createName="Create Society"
			prevPathName="Societies"
		/>
	),
	"/societiesparking/edit": (
		<CustomRouteHeader
			pathUrl="/societiesparking"
			createName="Edit Setting"
			prevPathName="Societies"
		/>
	),
	"/mapview": "Map View",
	"/visitorLogs": "Surveillance Logs",
	"/controllers/create": (
		<CustomRouteHeader
			pathUrl="/parkingControllers"
			createName="Create Controller"
			prevPathName="Controllers"
		/>
	),
	"/controllers/edit": (
		<CustomRouteHeader
			pathUrl="/parkingControllers"
			createName="Edit Controller"
			prevPathName="Controllers"
		/>
	),
	"/clientsInfo": "Clients Info",
	"/clientsInfo/create": (
		<CustomRouteHeader
			pathUrl="/clientsInfo"
			createName="Create Client"
			prevPathName="Client Info"
		/>
	),
	"/dashboardLogs": "Dashboard Logs",
	"/fasTagApiData": "API Data",
	"/getParkingTerminals": "Parking Terminals",
	"/getParkingTerminals/create": (
		<CustomRouteHeader
			pathUrl="/getParkingTerminals"
			createName="Create Parking Terminal"
			prevPathName="Parking Terminal"
		/>
	),
	"/parkingAnalytics": "Parking Analytics",
	"/purchasedFastags": "Purchased Fastags",
	"/parkingCameras": "Cameras",
	"/reports": "Reports",
	"/getFastagsStatus": "Check Status",
	"/monthlyPassPayment": "Payments",
	"/createSubUser": "Create Sub User",
	"/qrTransactions": "QR Transactions",
	"/parkingAreaLogs": "Occupancy",
	"/currentlyParked": "Currently Parked",
	"/settlements": "Settlements",
	"/dashboardInsights": "Dashboard Insights",
	"/contactUs": "Contact Us",
	"/valets/bookings": "Valet Bookings",
	"/barrierActivities": "Barrier Activities",
	"/missedVisitors": "Missed Visitors",
	"/qrCodeMonthlyPass": "QR Codes",
	"/invoices/user-permit": "Permit Users",
	"/invoices/user-permit/edit": "Invoice Details",
	"/invoices/vaahan-api": "Vahan APIs",
	"/invoices/vaahan-api/edit": "Invoice Details",
	"/fastagStatus": "FASTag Status",
	"/bulkPermitsOnboarding": "Bulk Onboarding",
	"/slotsInventory": "Slots",
	"/valet/passes": "Valet Passes",
	"/gracePeriod/logs": "Grace Period Logs",
	"/gracePeriod/configurations": "Grace Period Configuration",
	"/bulkUpdatePermitFastag": "Update Permit Fastag"
};

const useStyles = makeStyles({
	root: {
		display: "flex",
		flex: 1,
		minHeight: "100vh",
		backgroundColor: customTheme.palette.background.paper,
	},
	sidebar: {
		display: "flex",
		flexDirection: "column",
		flex: 1,
		height: "100%",
		borderRadius: 0,
		position: "fixed",
		top: 0,
		zIndex: 1000,
		textAlign: "center",
		transition: "width 0.2s",
		boxShadow: "6px 0px 18px rgba(0, 0, 0, 0.1)",
		// overflow: "scroll"
	},
	sidebarHeader: {
		display: "flex",
		minHeight: appBarHeight,
		height: appBarHeight,
		borderBottomWidth: 1,
		borderBottomStyle: "solid",
		borderColor: customTheme.palette.divider,
		alignItems: "center",
		justifyContent: "flex-start",
		position: "relative",
	},
	logo: {
		width: 100,
		marginLeft: 24,
	},
	logoSmallDevice: {
		width: 34,
		height: 34,
		marginTop: 8,
		borderRadius: 5,
	},
	titleContainer: {
		marginLeft: 12,
		transition: "width 0.2s",
		overflow: "hidden",
	},
	title: {
		fontSize: 16,
		fontWeight: "bold",
		overflow: "hidden",
	},
	toggleFab: {
		position: "absolute",
		right: -13,
		top: 13,
		backgroundColor: "#fff",
		width: 28,
		height: 28,
		minHeight: 0,
		"&:hover": {
			backgroundColor: "#e1e1e1",
		},
	},
	toggleIcon: {
		transition: "transform 0.2s",
	},
	menu: {
		marginTop: customTheme.spacing(1),
		display: "flex",
		flexDirection: "column",
		flex: 1,
		overflowX: "hidden",
	},
	menuSection: {
		margin: customTheme.spacing(1, 0),
	},
	menuSectionFlex: {
		flex: 1,
	},
	contentWithAppBar: {
		display: "flex",
		flexDirection: "column",
		flexGrow: 1,
		marginTop: appBarHeight,
		transition: "margin-left 0.2s",
		width: `calc(100% - ${sidebarOpenWidth}px)`,
	},
	appBar: {
		display: "flex",
		flexDirection: "row",
		height: appBarHeight + 1,
		zIndex: 999,
		borderBottomWidth: 1,
		borderBottomStyle: "solid",
		borderColor: customTheme.palette.divider,
		alignItems: "center",
		justifyContent: "space-between",
		backgroundColor: customTheme.palette.background.paper,
		transition: "left 0.2s width 0.2s",
	},
	content: {
		display: "flex",
		flexDirection: "column",
		flexGrow: 2,
		padding: customTheme.spacing(3),
	},
	blockContainer: {
		display: "block",
	},
	dialogPaper: {
		padding: "14px 20px",
	},
	avatar: {
		backgroundColor: customTheme.palette.primary.main,
		textTransform: "uppercase",
	},
	backDrop: {
		backdropFilter: "blur(3px)",
		backgroundColor: "rgba(0,0,30,0.4)",
	},
});

const resetCustomReduxStates = (dispatch) => {
	//Parking Selector
	dispatch({
		type: "UPDATE_PARKINGS",
		payload: {
			parkings: { loading: true },
		},
	});

	//Parking Summary Overall
	dispatch({
		type: "UPDATE_PARKING_SUMMARY",
		payload: {
			parkingSummary: { loading: true },
		},
	});

	//Monthly Pass Parking Filter
	dispatch({
		type: "UPDATE_MONTHLY_PASS_PARKING",
		payload: {
			monthlyPassParking: {},
		},
	});
};

const renderIcon = (resource) =>
	resource.icon ? resource.icon : <DefaultIcon />;
const renderSelectedIcon = (resource) =>
	resource.options && resource.options.selectedIcon
		? resource.options.selectedIcon
		: renderIcon(resource);
const CustomLayout = (props) => {
	const { children, theme } = props;
	const isSmallDevice = useMediaQuery((theme) =>
		customTheme.breakpoints.down("xs")
	);
	const { sectionLoader, setIsActive, setCurrentPathName, setSectionLoader } =
		useContext(ContextProvider);
	const classes = useStyles(props);
	//const notify = useNotify();
	const dispatch = useDispatch();
	//const location = useLocation()
	const open = useSelector((state) => state.admin.ui.sidebarOpen);
	const resources = useSelector(getResources);
	//const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
	const routePath = useSelector((state) => state.router.location.pathname);
	const permitRequestsCount = useSelector((state) => state.permitRequests);
	const onLogout = useLogout();

	const [drawerVisible, setDrawerVisible] = useState(false);
	const [sessionTimedout, setSessionTimedout] = useState(false);
	const [displayName] = useState(sessionStorage.getItem("display_name"));
	const [fullName] = useState(sessionStorage.getItem("full_name"));
	const [userName] = useState(sessionStorage.getItem("username"));
	const [avatarAnchor, setAvatarAnchor] = useState(null);
	const [avatarAnchorName, setAvatarAnchorName] = useState(null);
	const [vehicleSummaryName] = useState(
		sessionStorage.getItem("vehicle_summary_name")
	);
	const [tutorials] = useState(getTutorials());
	const [apartmentAsUnit] = useState(sessionStorage.getItem("show_apartment_as_unit") === "1" ? "Units" : "Apartments")
	const [sessionTimeoutInSeconds] = useState(sessionStorage.getItem('inactivity_limit_seconds'))
	if(apartmentAsUnit === "Units") {
		resourceLabel["/rfidApartments"] = "Units"
		resourceLabel["/permitApartments"] = "Units" 
		resourceLabel["/rfidApartments/edit"] = (
			<CustomRouteHeader
				pathUrl="/rfidApartments"
				createName="Edit Units"
				prevPathName="Units"
			/>
		)
	}

	// let showParkingSelectorToResource = ["/rfidInventory", "/permitLogs", "/rfidPayments", "/rfidData", "/rfidRequests", "/rfidOrganization", "/rfidApartments", "/crmUsers", "/parkingSlotBookings", "/exemptedVehicles", "/monthlyPassRequest", "/operator/users", "/operator/devices", "/operator/shifts", "/inventory", "/cardsInventory", "/deviceWalletsTransactions", "/deviceWallet", "/scannedTagsDetails", "/rfidsDeletedDetails", "/anprUploadImages", "/siteAudits", "warriorusers", "societiesparking"]


	const onIdle = () => {
		setSessionTimedout(true);
		sessionStorage.clear();
	};

	useIdleTimer({
		timeout: sessionTimeoutInSeconds && !isNaN(sessionTimeoutInSeconds) ? Number(sessionTimeoutInSeconds) * 1000 : 1000 * 60 * 15,
		onIdle: onIdle,
	});

	const toggleSidebar = () => {
		dispatch(setSidebarVisibility(!open));
	};

	const showResourcesSeparately =
		sessionStorage.getItem("show_resources_separately") === "1"
			? []
			: [
				"rfidData",
				"permitLogs",
				"rfidPayments",
				"rfidOrganization",
				"rfidApartments",
				"rfidRequests",
				"rfidInventory",
			];
	const showResourcesSeparatelyPermit =
		sessionStorage.getItem("show_resources_separately") === "1"
			? []
			: [
				"permit/logs",
				"permit/payments",
				"permit/users",
				"permitRequests",
				"permitOrganization",
				"permitApartments",
				"permitInventory",
				"permitDeletedDetails",
			];
	const renderMenuItems = () => {
		const menuExpanded = isSmallDevice ? true : open;
		return (
			<div className={[classes.menu, "mainMenu", "menuScroll"].join(" ")}>
				<div
					className={[classes.menuSection, classes.menuSectionFlex].join(" ")}>
					{sessionStorage.getItem("hide_parking_section") !== "1" ? (
						menuExpanded ? (
							<Tooltip
								title="Real-time status of parking spaces, gates, and revenue collected"
								placement="bottom-end">
								<MenuItemLink
									id="step-1-test"
									to="/parkings"
									primaryText="Parkings"
									leftIcon={<PlaceOutlinedIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/parkings`).test(routePath)
											? "RaMenuItemLink-active source-element"
											: "RaMenuItemLink-default source-element"
									}
								/>
							</Tooltip>
						) : (
							<Link to="/parkings">
								<IconButton>
									<PlaceOutlinedIcon />
								</IconButton>
							</Link>
						)
					) : (
						sessionStorage.getItem("redirect_after_login") ===
						"/vehicleSummary" &&
						(menuExpanded ? (
							<MenuItemLink
								id="society_step-12"
								to="/vehicleSummary"
								primaryText={
									vehicleSummaryName ? vehicleSummaryName : "Vehicle Summary"
								}
								leftIcon={<DirectionsCarIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/parkings`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/vehicleSummary">
								<IconButton>
									<DirectionsCarIcon />
								</IconButton>
							</Link>
						))
					)}
					{sessionStorage.getItem("show_ieems_section") === "1" &&
						(menuExpanded ? (
							<Tooltip
								title="Vehicle entries, exits, occupancy status, and society performance"
								placement="bottom-end">
								<MenuItemLink
									id="step-2-test"
									to="/societiesparking"
									primaryText="Societies"
									leftIcon={<EmojiTransportationOutlinedIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/societiesparking`).test(routePath)
											? "RaMenuItemLink-active source-element"
											: "RaMenuItemLink-default source-element"
									}
								/>
							</Tooltip>
						) : (
							<Link to="/societiesparking">
								<IconButton>
									<EmojiTransportationOutlinedIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_currently_parked") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								id="society_step-16"
								to="/currentlyParked"
								primaryText="Currently Parked"
								leftIcon={<DirectionsCarIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/currentlyParked`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/currentlyParked">
								<IconButton>
									<DirectionsCarIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_settlements") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/settlements"
								primaryText="Settlements"
								leftIcon={<PaymentIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/settlements`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/settlements">
								<IconButton>
									<DirectionsCarIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_reports") === "1" && sessionStorage.getItem("role") === "admin" &&
						(menuExpanded ? (
							<MenuItemLink
								id="society_step-15"
								to="/reports"
								primaryText="Reports"
								leftIcon={<DescriptionIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/reports`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/reports">
								<IconButton>
									<DescriptionIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_map_view") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/mapview"
								primaryText="Map View"
								leftIcon={<MapOutlinedIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/mapview`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/mapview">
								<IconButton>
									<MapOutlinedIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_parking_details") === "1" &&
						sessionStorage.getItem("hide_parking_details") !== "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/parkingInfo"
								primaryText="Parking Details"
								leftIcon={<LocalParkingIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/parkingInfo`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/parkingInfo">
								<IconButton>
									<LocalParkingIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_parking_analytics") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/parkingAnalytics"
								primaryText="Parking Analytics"
								leftIcon={<AssessmentIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/parkingAnalytics`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/parkingAnalytics">
								<IconButton>
									<AssessmentIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_dashboard_insights") === "1" && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Site Monitoring"
							icon={<AccountBalanceWalletIcon />}
							routePath={routePath}>
							{menuExpanded ? (
								<MenuItemLink
									to="/dashboardInsights"
									primaryText="Dashboard Insights"
									leftIcon={<AssessmentIcon />}
									sidebarIsOpen={menuExpanded}
									className={new RegExp(`^/dashboardInsights`).test(routePath) ? "RaMenuItemLink-active" : "RaMenuItemLink-default"}
								/>

							) : (
								<Link to="/dashboardInsights">
									<IconButton><AssessmentIcon /></IconButton>
								</Link>
							)}
							{menuExpanded ? (
								<MenuItemLink
									to="/fastagStatus"
									primaryText="FASTag Status"
									leftIcon={<PaymentIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/fastagStatus`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/fastagStatus">
									<IconButton>
										<AccountBalanceWalletIcon />
									</IconButton>
								</Link>
							)}
						</SubMenu>
					)}
					{sessionStorage.getItem("show_valet_bookings") === "1" && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Valet"
							icon={<DirectionsCarIcon />}
							routePath={routePath}>
							{menuExpanded ? (
								<MenuItemLink
								to="/valets/bookings"
								primaryText="Bookings"
								leftIcon={<ConfirmationNumberOutlinedIcon />}
								sidebarIsOpen={menuExpanded}
								className={new RegExp(`^/valets/bookings`).test(routePath) ? "RaMenuItemLink-active" : "RaMenuItemLink-default"}
							/>

							) : (
								<Link to="/valets/bookings">
							<IconButton><ConfirmationNumberOutlinedIcon /></IconButton>
						</Link>
							)}
							{menuExpanded ? (
								<MenuItemLink
								to="/valet/passes"
								primaryText="Passes"
								leftIcon={<PeopleOutlineIcon />}
								sidebarIsOpen={menuExpanded}
								className={new RegExp(`^/valet/passes`).test(routePath) ? "RaMenuItemLink-active" : "RaMenuItemLink-default"}
							/>

							) : (
								<Link to="/valet/passes">
							<IconButton><PeopleOutlineIcon /></IconButton>
						</Link>
							)}
						</SubMenu>
					)}
					{(sessionStorage.getItem('show_grace_period') === "1") && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Grace Period"
							icon={<AccountBalanceWalletIcon />}
							routePath={routePath}>
							{(sessionStorage.getItem('show_grace_period_logs') === "1") &&
								(menuExpanded ? (
									<MenuItemLink
										to="/gracePeriod/logs"
										primaryText="Logs"
										leftIcon={<AssessmentIcon />}
										sidebarIsOpen={menuExpanded}
										className={new RegExp(`^/gracePeriod/logs`).test(routePath) ? "RaMenuItemLink-active" : "RaMenuItemLink-default"}
									/>

								) : (
									<Link to="/gracePeriod/logs">
										<IconButton><AssessmentIcon /></IconButton>
									</Link>
								))
							}
							{(sessionStorage.getItem('show_grace_period_configurations') === "1") &&
								(menuExpanded ? (
									<MenuItemLink
										to="/gracePeriod/configurations"
										primaryText="Configuration"
										leftIcon={<PaymentIcon />}
										sidebarIsOpen={menuExpanded}
										className={
											new RegExp(`^/gracePeriod/configurations`).test(routePath)
												? "RaMenuItemLink-active"
												: "RaMenuItemLink-default"
										}
									/>
								) : (
									<Link to="/gracePeriod/configurations">
										<IconButton>
											<AccountBalanceWalletIcon />
										</IconButton>
									</Link>
								))
							}
						</SubMenu>
					)}
					{sessionStorage.getItem("show_parking_terminals") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/getParkingTerminals"
								primaryText="Parking Terminals"
								leftIcon={<ConfirmationNumberOutlinedIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/getParkingTerminals`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/getParkingTerminals">
								<IconButton>
									<ConfirmationNumberOutlinedIcon />
								</IconButton>
							</Link>
						))}
					{(sessionStorage.getItem("show_operator") === "1") && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Operator"
							icon={<PhonelinkRingIcon />}
							routePath={routePath}>
							{(sessionStorage.getItem("show_operator_users") === "1") &&
								menuExpanded ? (
								<MenuItemLink
									to="/operator/users"
									primaryText="Users"
									leftIcon={
										<img
											src={
												new RegExp(`^/operator/users`).test(routePath)
													? UsersGreenIcon
													: UsersDefaultIcon
											}
											alt="Users"
										/>
									}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/operator/users`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : sessionStorage.getItem("show_operator_users") === "1" ? (
								<Link to="/operator/users">
									<IconButton>
										<img
											src={
												new RegExp(`^/operator/users`).test(routePath)
													? UsersGreenIcon
													: UsersDefaultIcon
											}
											alt="Users"
										/>
									</IconButton>
								</Link>
							) : null }
							{(sessionStorage.getItem("show_operator_devices") === "1") && 
								menuExpanded ? (
								<MenuItemLink
									to="/operator/devices"
									primaryText="Devices"
									leftIcon={<PhonelinkRingIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/operator/devices`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : sessionStorage.getItem("show_operator_devices") === "1" ? (
								<Link to="/operator/devices">
									<IconButton>
										<PhonelinkRingIcon />
									</IconButton>
								</Link>
							) : null}
							{(sessionStorage.getItem("show_operator_shifts") === "1") &&
							menuExpanded ? (
								<MenuItemLink
									to="/operator/shifts"
									primaryText="Shifts"
									leftIcon={
										<img
											src={
												new RegExp(`^/operator/shifts`).test(routePath)
													? LogsGreenIcon
													: LogsDefaultIcon
											}
											alt="Logs"
										/>
									}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/operator/shifts`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : sessionStorage.getItem("show_operator_shifts") === "1" ? (
								<Link to="/operator/shifts">
									<IconButton>
										<img
											src={
												new RegExp(`^/operator/shifts`).test(routePath)
													? LogsGreenIcon
													: LogsDefaultIcon
											}
											alt="Logs"
										/>
									</IconButton>
								</Link>
							) : null}
							{sessionStorage.getItem("show_patrolling") === "1" &&
								menuExpanded ? (
								<MenuItemLink
									to="/operator/patrolling"
									primaryText="Patrolling"
									leftIcon={
										<img
											src={
												new RegExp(`^/operator/patrolling`).test(routePath)
													? LogsGreenIcon
													: LogsDefaultIcon
											}
											alt="Logs"
										/>
									}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/operator/patrolling`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : sessionStorage.getItem("show_patrolling") === "1" ? (
								<Link to="/operator/patrolling">
									<IconButton>
										<img
											src={
												new RegExp(`^/operator/patrolling`).test(routePath)
													? LogsGreenIcon
													: LogsDefaultIcon
											}
											alt="Logs"
										/>
									</IconButton>
								</Link>
							) : null}

							{sessionStorage.getItem("show_patrolling") === "1" &&
								menuExpanded ? (
								<MenuItemLink
									to="/appUpdateUrls"
									primaryText="App Version"
									leftIcon={
										<img
											src={
												new RegExp(`^/appUpdateUrls`).test(routePath)
													? LogsGreenIcon
													: LogsDefaultIcon
											}
											alt="Logs"
										/>
									}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/appUpdateUrls`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : sessionStorage.getItem("show_patrolling") === "1" ? (
								<Link to="/appUpdateUrls">
									<IconButton>
										<img
											src={
												new RegExp(`^/appUpdateUrls`).test(routePath)
													? LogsGreenIcon
													: LogsDefaultIcon
											}
											alt="Logs"
										/>
									</IconButton>
								</Link>
							) : null}

						</SubMenu>
					)}

					{sessionStorage.getItem("show_dashboard_users") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/crmUsers"
								primaryText={"Dashboard Users"}
								leftIcon={
									<img
										src={
											new RegExp(`^/crmUsers(/[A-z]*)*$`).test(routePath)
												? UsersGreenIcon
												: UsersDefaultIcon
										}
										alt="Users"
									/>
								}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/crmUsers`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/crmUsers">
								<IconButton>
									<img
										src={
											new RegExp(`^/crmUsers/?`).test(routePath)
												? UsersGreenIcon
												: UsersDefaultIcon
										}
										alt="Users"
									/>
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_verify_vehicle") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/jammuUsers"
								primaryText="App Users"
								leftIcon={<PeopleOutlineIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/jammuUsers`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/jammuUsers">
								<IconButton>
									<PeopleOutlineIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_verify_vehicle") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/verifyVehicles"
								primaryText="Vehicles"
								leftIcon={<DirectionsCarIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/verifyVehicles`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/verifyVehicles">
								<IconButton>
									<DirectionsCarIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("all_parkings_details") === "1" && (
						<Badge
							color="error"
							badgeContent="Beta"
							classes={{
								root: "navMenuLinkBadgeContainer",
								badge: "navMenuLinkBadge",
							}}>
							{menuExpanded ? (
								<MenuItemLink
									to="/allParkingsDetails"
									primaryText="All Parkings Logs"
									leftIcon={<BusinessIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/allParkingsDetails`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/allParkingsDetails">
									<IconButton>
										<BusinessIcon />
									</IconButton>
								</Link>
							)}
						</Badge>
					)}
					{sessionStorage.getItem("show_monthly_pass") === "1" && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Monthly Pass"
							defaultExpanded={
								sessionStorage.getItem("show_monthly_pass") === "1"
							}
							icon={<ConfirmationNumberOutlinedIcon />}
							routePath={routePath}>
							{sessionStorage.getItem("show_monthly_pass_log") === "1" &&
								(menuExpanded ? (
									<MenuItemLink
										id="society_step-17"
										to="/monthlyPassLog"
										primaryText="Logs"
										leftIcon={
											<img
												src={
													new RegExp(`^/monthlyPassLog`).test(routePath)
														? LogsGreenIcon
														: LogsDefaultIcon
												}
												alt="Logs"
											/>
										}
										sidebarIsOpen={menuExpanded}
										className={
											new RegExp(`^/monthlyPassLog`).test(routePath)
												? "RaMenuItemLink-active"
												: "RaMenuItemLink-default"
										}
									/>
								) : (
									<Link to="/monthlyPassLog">
										<IconButton>
											<img
												src={
													new RegExp(`^/monthlyPassLog`).test(routePath)
														? LogsGreenIcon
														: LogsDefaultIcon
												}
												alt="Logs"
											/>
										</IconButton>
									</Link>
								))}
							{sessionStorage.getItem("show_monthly_pass_log") === "1" &&
								(menuExpanded ? (
									<Tooltip title="Payments">
										<MenuItemLink
											id="society_step-18"
											to="/monthlyPassPayment"
											primaryText="Payments"
											leftIcon={
												<img
													src={
														new RegExp(`^/monthlyPassPayment`).test(routePath)
															? LogsGreenIcon
															: LogsDefaultIcon
													}
													alt="Logs"
												/>
											}
											sidebarIsOpen={menuExpanded}
											className={
												new RegExp(`^/monthlyPassPayment`).test(routePath)
													? "RaMenuItemLink-active"
													: "RaMenuItemLink-default"
											}
										/>
									</Tooltip>
								) : (
									<Link to="/monthlyPassPayment">
										<IconButton>
											<img
												src={
													new RegExp(`^/monthlyPassPayment`).test(routePath)
														? LogsGreenIcon
														: LogsDefaultIcon
												}
												alt="Logs"
											/>
										</IconButton>
									</Link>
								))}
							{menuExpanded ? (
								<MenuItemLink
									to="/monthlyPass"
									id="society_step-19"
									primaryText="Users"
									leftIcon={
										<img
											src={
												new RegExp(`^/monthlyPass(/[A-z]*)*$`).test(routePath)
													? UsersGreenIcon
													: UsersDefaultIcon
											}
											alt="Users"
										/>
									}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/monthlyPass(/[A-z]*)*$`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/monthlyPass">
									<IconButton>
										<img
											src={
												new RegExp(`^/monthlyPass/?`).test(routePath)
													? UsersGreenIcon
													: UsersDefaultIcon
											}
											alt="Users"
										/>
									</IconButton>
								</Link>
							)}
							{sessionStorage.getItem("show_monthlypass_request") === "1" &&
								(menuExpanded ? (
									<MenuItemLink
										to="/monthlyPassRequest"
										primaryText="Request"
										leftIcon={<ContactMail />}
										sidebarIsOpen={menuExpanded}
										className={
											new RegExp(`^/monthlyPassRequest`).test(routePath)
												? "RaMenuItemLink-active"
												: "RaMenuItemLink-default"
										}
									/>
								) : (
									<Link to="/monthlyPassRequest">
										<IconButton
											className={
												new RegExp(`^/monthlyPassRequest`).test(routePath)
													? "RaMenuItemLink-active"
													: "RaMenuItemLink-default"
											}>
											<ContactMail />
										</IconButton>
									</Link>
								))}
						</SubMenu>
					)}
					{((sessionStorage.getItem("show_rfid") === "1" &&
						sessionStorage.getItem("show_resources_separately") === "0")) && (
							<Tooltip title={"Menu"} placement="right">
								<SubMenu
									sidebarIsOpen={menuExpanded}
									name="Permit"
									icon={<img src={PermitDefaultIcon} alt="Permit" />}
									badgeContent={
										sessionStorage.getItem("show_rfid_requests") === "1"
											? permitRequestsCount
											: 0
									}
									defaultExpanded={
										sessionStorage.getItem("show_rfid") === "1"
									}
									routePath={routePath}>
									{(sessionStorage.getItem("show_rfid") === "1" &&
										sessionStorage.getItem("show_rfid_logs") === "1") &&
										(menuExpanded ? (
											<Tooltip title={"Logs"} placement="bottom-end">
												<MenuItemLink
													id="society_step-1"
													to="/permitLogs"
													primaryText="Logs"
													leftIcon={
														<img
															src={
																new RegExp(`^/permitLogs`).test(routePath)
																	? LogsGreenIcon
																	: LogsDefaultIcon
															}
															alt="Logs"
														/>
													}
													sidebarIsOpen={menuExpanded}
													className={
														new RegExp(`^/permitLogs`).test(routePath)
															? "RaMenuItemLink-active source-element"
															: "RaMenuItemLink-default source-element"
													}
												/>
											</Tooltip>
										) : (
											<Link to="/permitLogs">
												<IconButton>
													<img
														src={
															new RegExp(`^/permitLogs`).test(routePath)
																? LogsGreenIcon
																: LogsDefaultIcon
														}
														alt="Logs"
													/>
												</IconButton>
											</Link>
										))}
									{sessionStorage.getItem("show_validity_column") === "1" &&
										sessionStorage.getItem("show_rfid_payments") === "1" &&
										(menuExpanded ? (
											<Tooltip title={"Payments"} placement="bottom-end">
												<MenuItemLink
													id="society_step-8"
													to="/rfidPayments"
													primaryText="Payments"
													leftIcon={<PaymentIcon />}
													sidebarIsOpen={menuExpanded}
													className={
														new RegExp(`^/rfidPayments`).test(routePath)
															? "RaMenuItemLink-active"
															: "RaMenuItemLink-default"
													}
												/>
											</Tooltip>
										) : (
											<Link to="/rfidPayments">
												<IconButton>
													<PaymentIcon />
												</IconButton>
											</Link>
										))}
									{sessionStorage.getItem("show_rfid") === "1" &&
										(menuExpanded ? (
											<Tooltip title={"Users"} placement="bottom-end">
												<MenuItemLink
													id="society_step-2"
													to="/rfidData"
													primaryText="Users"
													leftIcon={
														<img
															src={
																new RegExp(`^/rfidData`).test(routePath)
																	? UsersGreenIcon
																	: UsersDefaultIcon
															}
															alt="Users"
														/>
													}
													sidebarIsOpen={menuExpanded}
													className={
														new RegExp(`^/rfidData`).test(routePath)
															? "RaMenuItemLink-active source-element"
															: "RaMenuItemLink-default source-element"
													}
												/>
											</Tooltip>
										) : (
											<Link to="/rfidData">
												<IconButton>
													<img
														src={
															new RegExp(`^/rfidData`).test(routePath)
																? UsersGreenIcon
																: UsersDefaultIcon
														}
														alt="Users"
													/>
												</IconButton>
											</Link>
										))}
									{sessionStorage.getItem("show_rfid_requests") === "1" && (
										<Badge
											color="error"
											badgeContent={permitRequestsCount}
											classes={{
												root: "navMenuLinkBadgeContainer",
												badge: "navMenuLinkBadge",
											}}>
											{menuExpanded ? (
												<Tooltip title={"Requests"} placement="bottom-end">
													<MenuItemLink
														id="society_step-3"
														to="/rfidRequests"
														primaryText="Requests"
														leftIcon={<PersonAddIcon />}
														sidebarIsOpen={menuExpanded}
														className={
															new RegExp(`^/rfidRequests`).test(routePath)
																? "RaMenuItemLink-active source-element"
																: "RaMenuItemLink-default source-element"
														}
													/>
												</Tooltip>
											) : (
												<Link to="/rfidRequests">
													<IconButton>
														<PersonAddIcon />
													</IconButton>
												</Link>
											)}
										</Badge>
									)}
									{sessionStorage.getItem("show_rfid_company") === "1" &&
										sessionStorage.getItem("company_user") !== "1" &&
										(menuExpanded ? (
											<Tooltip title={"Company"} placement="bottom-end">
												<MenuItemLink
													id="society_step-4"
													to="/rfidOrganization"
													primaryText="Company"
													leftIcon={
														<img
															src={
																new RegExp(`^/rfidOrganization`).test(routePath)
																	? CompanyGreenIcon
																	: CompanyDefaultIcon
															}
															alt="Company"
														/>
													}
													sidebarIsOpen={menuExpanded}
													className={
														new RegExp(`^/rfidOrganization`).test(routePath)
															? "RaMenuItemLink-active"
															: "RaMenuItemLink-default"
													}
												/>
											</Tooltip>
										) : (
											<Link to="/rfidOrganization">
												<IconButton>
													<img
														src={
															new RegExp(`^/rfidOrganization`).test(routePath)
																? CompanyGreenIcon
																: CompanyDefaultIcon
														}
														alt="Company"
													/>
												</IconButton>
											</Link>
										))}
									{sessionStorage.getItem("show_permit_apartments") === "1" && (
										<Badge
											color="error"
											badgeContent="Beta"
											classes={{
												root: "navMenuLinkBadgeContainer",
												badge: "navMenuLinkBadge",
											}}>
											{menuExpanded ? (
												<Tooltip title={apartmentAsUnit} placement="bottom-end">
													<MenuItemLink
														id="society_step-5"
														to="/rfidApartments"
														primaryText={apartmentAsUnit}
														leftIcon={<ApartmentOutlinedIcon />}
														sidebarIsOpen={menuExpanded}
														className={
															new RegExp(`^/rfidApartments`).test(routePath)
																? "RaMenuItemLink-active source-element"
																: "RaMenuItemLink-default source-element"
														}
													/>
												</Tooltip>
											) : (
												<Link to="/rfidApartments">
													<IconButton>
														<ApartmentOutlinedIcon />
													</IconButton>
												</Link>
											)}
										</Badge>
									)}
									{sessionStorage.getItem("show_permit_apartments") === "1" &&
										(menuExpanded ? (
											<MenuItemLink
												to="/slotsInventory"
												primaryText="Slots"
												leftIcon={<ConfirmationNumberOutlinedIcon />}
												sidebarIsOpen={menuExpanded}
												className={
													new RegExp(`^/slotsInventory`).test(routePath)
														? "RaMenuItemLink-active"
														: "RaMenuItemLink-default"
												}
											/>
										) : (
											<Link to="/slotsInventory">
												<IconButton>
													<DeleteIcon />
												</IconButton>
											</Link>
										))}
									{sessionStorage.getItem("show_rfid_inventory") === "1" &&
										(menuExpanded ? (
											<Tooltip title={"Inventory"} placement="bottom-end">
												<MenuItemLink
													id="society_step-6"
													to="/rfidInventory"
													primaryText="Inventory"
													leftIcon={<BrandingWatermarkOutlinedIcon />}
													sidebarIsOpen={menuExpanded}
													className={
														new RegExp(`^/rfidInventory`).test(routePath)
															? "RaMenuItemLink-active"
															: "RaMenuItemLink-default"
													}
												/>
											</Tooltip>
										) : (
											<Link to="/rfidInventory">
												<IconButton>
													<BrandingWatermarkOutlinedIcon />
												</IconButton>
											</Link>
										))}
									{sessionStorage.getItem("show_rfid_deleted_details") === "1" &&
										(menuExpanded ? (
											<MenuItemLink
												id="society_step-7"
												to="/rfidsDeletedDetails"
												primaryText="Deleted"
												leftIcon={<DeleteIcon />}
												sidebarIsOpen={menuExpanded}
												className={
													new RegExp(`^/rfidsDeletedDetails`).test(routePath)
														? "RaMenuItemLink-active"
														: "RaMenuItemLink-default"
												}
											/>
										) : (
											<Link to="/rfidsDeletedDetails">
												<IconButton>
													<DeleteIcon />
												</IconButton>
											</Link>
										))}
									{sessionStorage.getItem("show_onboard_users") === "1" &&
										(menuExpanded ? (
											<MenuItemLink
												to="/bulkPermitsOnboarding"
												primaryText="Bulk Onboarding"
												leftIcon={
													<img
														src={
															new RegExp(`^/bulkPermitsOnboarding`).test(routePath)
																? UsersGreenIcon
																: UsersDefaultIcon
														}
														alt="Users"
													/>
												}
												sidebarIsOpen={menuExpanded}
												className={
													new RegExp(`^/bulkPermitsOnboarding`).test(routePath)
														? "RaMenuItemLink-active"
														: "RaMenuItemLink-default"
												}
											/>
										) : (
											<Link to="/bulkPermitsOnboarding">
												<IconButton>
												<img
														src={
															new RegExp(`^/rfidData`).test(routePath)
																? UsersGreenIcon
																: UsersDefaultIcon
														}
														alt="Users"
													/>
												</IconButton>
											</Link>
										))}
									{(sessionStorage.getItem("allow_bulk_update_permit_fastag") === "1") &&
										(menuExpanded ? (
											<MenuItemLink
												to="/bulkUpdatePermitFastag"
												primaryText="Update Permit Fastag"
												leftIcon={
													<img
														src={
															new RegExp(`^/bulkUpdatePermitFastag`).test(routePath)
																? UsersGreenIcon
																: UsersDefaultIcon
														}
														alt="Users"
													/>
												}
												sidebarIsOpen={menuExpanded}
												className={
													new RegExp(`^/bulkUpdatePermitFastag`).test(routePath)
														? "RaMenuItemLink-active"
														: "RaMenuItemLink-default"
												}
											/>
										) : (
											<Link to="/bulkUpdatePermitFastag">
												<IconButton>
												<img
														src={
															new RegExp(`^/rfidData`).test(routePath)
																? UsersGreenIcon
																: UsersDefaultIcon
														}
														alt="Users"
													/>
												</IconButton>
											</Link>
										))}
								</SubMenu>
							</Tooltip>
						)}
					{sessionStorage.getItem("show_reports") === "1" && sessionStorage.getItem("role") !== "admin" &&
						(menuExpanded ? (
							<MenuItemLink
								id="society_step-15"
								to="/reports"
								primaryText="Reports"
								leftIcon={<DescriptionIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/reports`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/reports">
								<IconButton>
									<DescriptionIcon />
								</IconButton>
							</Link>
						))}
					{((sessionStorage.getItem("show_rfid") === "1" &&
						sessionStorage.getItem("show_resources_separately") === "0") &&
						sessionStorage.getItem("show_permits") === "1") && (
							<Tooltip title={"Menu"} placement="right">
								<SubMenu
									sidebarIsOpen={menuExpanded}
									name="Permit"
									icon={<img src={PermitDefaultIcon} alt="Permit" />}
									badgeContent={
										sessionStorage.getItem("show_rfid_requests") === "1"
										&& "Beta"
									}
									defaultExpanded={
										sessionStorage.getItem("hide_parking_section") === "1"
									}
									routePath={routePath}>
									{(sessionStorage.getItem("show_rfid") === "1" &&
										sessionStorage.getItem("show_rfid_logs") === "1") &&
										(menuExpanded ? (
											<Tooltip title={"Logs"} placement="bottom-end">
												<MenuItemLink
													id="society_step-1"
													to="/permit/logs"
													primaryText="Permit Logs"
													leftIcon={
														<img
															src={
																new RegExp(`^/permit/logs`).test(routePath)
																	? LogsGreenIcon
																	: LogsDefaultIcon
															}
															alt="Logs"
														/>
													}
													sidebarIsOpen={menuExpanded}
													className={
														new RegExp(`^/permit/logs`).test(routePath)
															? "RaMenuItemLink-active source-element"
															: "RaMenuItemLink-default source-element"
													}
												/>
											</Tooltip>
										) : (
											<Link to="/permit/logs">
												<IconButton>
													<img
														src={
															new RegExp(`^/permit/logs`).test(routePath)
																? LogsGreenIcon
																: LogsDefaultIcon
														}
														alt="Logs"
													/>
												</IconButton>
											</Link>
										))}
									{sessionStorage.getItem("show_validity_column") === "1" &&
										sessionStorage.getItem("show_rfid_payments") === "1" &&
										(menuExpanded ? (
											<Tooltip title={"Payments"} placement="bottom-end">
												<MenuItemLink
													to="/permit/payments"
													primaryText="Permit Payments"
													leftIcon={<PaymentIcon />}
													sidebarIsOpen={menuExpanded}
													className={
														new RegExp(`^/permit/payments`).test(routePath)
															? "RaMenuItemLink-active"
															: "RaMenuItemLink-default"
													}
												/>
											</Tooltip>
										) : (
											<Link to="/permit/payments">
												<IconButton>
													<PaymentIcon />
												</IconButton>
											</Link>
										))}
									{sessionStorage.getItem("show_rfid") === "1" &&
										(menuExpanded ? (
											<Tooltip title={"Users"} placement="bottom-end">
												<MenuItemLink
													id="society_step-2"
													to="/permit/users"
													primaryText="Permit Users"
													leftIcon={
														<img
															src={
																new RegExp(`^/permit/users`).test(routePath)
																	? UsersGreenIcon
																	: UsersDefaultIcon
															}
															alt="Users"
														/>
													}
													sidebarIsOpen={menuExpanded}
													className={
														new RegExp(`^/permit/users`).test(routePath)
															? "RaMenuItemLink-active source-element"
															: "RaMenuItemLink-default source-element"
													}
												/>
											</Tooltip>
										) : (
											<Link to="/permit/users">
												<IconButton>
													<img
														src={
															new RegExp(`^/permit/users`).test(routePath)
																? UsersGreenIcon
																: UsersDefaultIcon
														}
														alt="Users"
													/>
												</IconButton>
											</Link>
										))}
								</SubMenu>
							</Tooltip>
						)}


					{/* {(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('show_visitor_logs') === "1") &&
					<Badge color="error" badgeContent='Beta' classes={{ root: "navMenuLinkBadgeContainer", badge: "navMenuLinkBadge" }}>
						{menuExpanded ?
							<MenuItemLink
								to="/scannedTagsDetails"
								primaryText="Visitor Logs"
								leftIcon={<LocalOfferIcon />}
								sidebarIsOpen={menuExpanded}
								className={new RegExp(`^/scannedTagsDetails`).test(routePath) ? "RaMenuItemLink-active" : "RaMenuItemLink-default"}
							/>
							:
							<Link to="/scannedTagsDetails">
								<IconButton><LocalOfferIcon /></IconButton>
							</Link>
						}
					</Badge>} */}
					{sessionStorage.getItem("show_visitor_logs") === "1" && (
						<Badge
							color="error"
							badgeContent="Beta"
							classes={{
								root: "navMenuLinkBadgeContainer",
								badge: "navMenuLinkBadge",
							}}>
							{menuExpanded ? (
								<Tooltip
									title="Live camera feed of entry and exit gates"
									placement="bottom-end">
									<MenuItemLink
										id='society_step-9'
										to="/visitorLogs"
										primaryText="Surveillance Logs"
										leftIcon={<LocalOfferIcon />}
										sidebarIsOpen={menuExpanded}
										className={
											new RegExp(`^/visitorLogs`).test(routePath)
												? "RaMenuItemLink-active"
												: "RaMenuItemLink-default"
										}
									/>
								</Tooltip>
							) : (
								<Link to="/visitorLogs">
									<IconButton>
										<LocalOfferIcon />
									</IconButton>
								</Link>
							)}
						</Badge>
					)}
					{sessionStorage.getItem('show_missed_visitors') === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/missedVisitors"
								primaryText="Missed Visitors"
								leftIcon={<LocalOfferIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/missedVisitors`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/missedVisitors">
								<IconButton>
									<LocalOfferIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_device_wallet") === "1" && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Wallets"
							icon={<AccountBalanceWalletIcon />}
							routePath={routePath}>
							{menuExpanded ? (
								<MenuItemLink
									to="/deviceWallet"
									primaryText="Device Wallet"
									leftIcon={<AccountBalanceWalletIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/deviceWallet(/[A-z]*)*$`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/deviceWallet">
									<IconButton>
										<AccountBalanceWalletIcon />
									</IconButton>
								</Link>
							)}
							{menuExpanded ? (
								<MenuItemLink
									to="/deviceWalletsTransactions"
									primaryText="Wallets Transactions"
									leftIcon={<PaymentIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/deviceWalletsTransactions`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/deviceWalletsTransactions">
									<IconButton>
										<AccountBalanceWalletIcon />
									</IconButton>
								</Link>
							)}
						</SubMenu>
					)}
					{sessionStorage.getItem("show_billing_invocies") === "1" && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Billings"
							icon={<AccountBalanceWalletIcon />}
							routePath={routePath}>
							{sessionStorage.getItem("show_invoices_user_permits") === "1" && (menuExpanded ? (
								<MenuItemLink
									to="/invoices/user-permit"
									primaryText="Permit Users"
									leftIcon={<AccountBalanceWalletIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/invoices/user-permit(/[A-z]*)*$`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/invoices/user-permit">
									<IconButton>
										<AccountBalanceWalletIcon />
									</IconButton>
								</Link>
							))}
							{sessionStorage.getItem("show_invoices_vaahan_api") === "1" && (menuExpanded ? (
								<MenuItemLink
									to="/invoices/vaahan-api"
									primaryText="Vahan APIs"
									leftIcon={<PaymentIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/invoices/vaahan-api`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/invoices/vaahan-api">
									<IconButton>
										<AccountBalanceWalletIcon />
									</IconButton>
								</Link>
							))}
						</SubMenu>
					)}
					{sessionStorage.getItem("show_parking_slot_booking") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/parkingSlotBookings"
								primaryText="Slot Bookings"
								leftIcon={<BookIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/parkingSlotBookings`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/parkingSlotBookings">
								<IconButton>
									<BookIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_exempted_vehicles") === "1" && (
						<Badge
							color="error"
							badgeContent="Beta"
							classes={{
								root: "navMenuLinkBadgeContainer",
								badge: "navMenuLinkBadge",
							}}>
							{menuExpanded ? (
								<MenuItemLink
									to="/exemptedVehicles"
									primaryText="VIP Vehicles"
									leftIcon={<BeenhereIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/exemptedVehicles`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/exemptedVehicles">
									<IconButton>
										<LocalOfferIcon />
									</IconButton>
								</Link>
							)}
						</Badge>
					)}
					{sessionStorage.getItem("show_site_audits") === "1" && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Warrior"
							icon={<PermDeviceInformationOutlinedIcon />}
							routePath={routePath}>
							{menuExpanded ? (
								<MenuItemLink
									to="/siteAudits"
									primaryText="Site Audits"
									leftIcon={<LibraryBooksOutlinedIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/siteAudits(/[A-z]*)*$`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/siteAudits">
									<IconButton>
										<LibraryBooksOutlinedIcon />
									</IconButton>
								</Link>
							)}
							{sessionStorage.getItem("show_warrior_users") === "1" &&
								(menuExpanded ? (
									<MenuItemLink
										to="/warriorusers"
										primaryText="Warrior Users"
										leftIcon={<LibraryBooksOutlinedIcon />}
										sidebarIsOpen={menuExpanded}
										className={
											new RegExp(`^/warriorusers(/[A-z]*)*$`).test(routePath)
												? "RaMenuItemLink-active"
												: "RaMenuItemLink-default"
										}
									/>
								) : (
									<Link to="/warriorusers">
										<IconButton>
											<LibraryBooksOutlinedIcon />
										</IconButton>
									</Link>
								))}
						</SubMenu>
					)}
					{sessionStorage.getItem("show_clients_info") === "1" && (
						<Badge
							color="error"
							badgeContent="Beta"
							classes={{
								root: "navMenuLinkBadgeContainer",
								badge: "navMenuLinkBadge",
							}}>
							{menuExpanded ? (
								<MenuItemLink
									to="/clientsInfo"
									primaryText="Clients Info"
									leftIcon={<BeenhereIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/clientsInfo`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/clientsInfo">
									<IconButton>
										<LocalOfferIcon />
									</IconButton>
								</Link>
							)}
						</Badge>
					)}
					{sessionStorage.getItem("show_inventory") === "1" && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Inventory"
							icon={<InventoryIcon />}
							routePath={routePath}>
							{sessionStorage.getItem("show_inventory_home") === "1" && (menuExpanded ? (
								<MenuItemLink
									to="/inventory"
									primaryText="Home"
									leftIcon={<WarehouseIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/inventory`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/inventory">
									<IconButton>
										<WarehouseIcon />
									</IconButton>
								</Link>
							))}
							{sessionStorage.getItem("show_rfid_inventory") === "1" && (menuExpanded ? (
								<MenuItemLink
									to="/rfidInventory"
									primaryText="Tags"
									leftIcon={<BrandingWatermarkOutlinedIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/rfidInventory`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/rfidInventory">
									<IconButton>
										<BrandingWatermarkOutlinedIcon />
									</IconButton>
								</Link>
							))}
							{sessionStorage.getItem("show_card_inventory") === "1" &&
								(menuExpanded ? (
									<MenuItemLink
										to="/cardsInventory"
										primaryText="Cards"
										leftIcon={<SdCardOutlinedIcon />}
										sidebarIsOpen={menuExpanded}
										className={
											new RegExp(`^/cardsInventory`).test(routePath)
												? "RaMenuItemLink-active"
												: "RaMenuItemLink-default"
										}
									/>
								) : (
									<Link to="/cardsInventory">
										<IconButton>
											<SdCardOutlinedIcon />
										</IconButton>
									</Link>
								))}
							{sessionStorage.getItem("show_qr_codes") === "1" &&
								(menuExpanded ? (
									<MenuItemLink
										to="/qrCodeMonthlyPass"
										primaryText="Qr Codes"
										leftIcon={<BookIcon />}
										sidebarIsOpen={menuExpanded}
										className={
											new RegExp(`^/qrCodeMonthlyPass`).test(routePath)
												? "RaMenuItemLink-active"
												: "RaMenuItemLink-default"
										}
									/>
								) : (
									<Link to="/qrCodeMonthlyPass">
										<IconButton>
											<BookIcon />
										</IconButton>
									</Link>
								))}
						</SubMenu>
					)}
					{sessionStorage.getItem("show_fastag_api_data") === "1" && (
						<SubMenu
							sidebarIsOpen={menuExpanded}
							name="Fastags"
							icon={<InventoryIcon />}
							routePath={routePath}>
							{menuExpanded ? (
								<MenuItemLink
									to="/fasTagApiData"
									primaryText="API Data"
									leftIcon={<ConfirmationNumberOutlinedIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/fasTagApiData`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/fasTagApiData">
									<IconButton>
										<ConfirmationNumberOutlinedIcon />
									</IconButton>
								</Link>
							)}
							{menuExpanded ? (
								<MenuItemLink
									to="/getFastagsStatus"
									primaryText="Check Status"
									leftIcon={<ConfirmationNumberOutlinedIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/getFastagsStatus`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							) : (
								<Link to="/getFastagsStatus">
									<IconButton>
										<ConfirmationNumberOutlinedIcon />
									</IconButton>
								</Link>
							)}
						</SubMenu>
					)}
					{sessionStorage.getItem("show_qr_transactions") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to="/qrTransactions"
								primaryText="QR Transactions"
								leftIcon={<AccountBalanceWalletIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/qrTransactions`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/qrTransactions">
								<IconButton>
									<AccountBalanceWalletIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("show_floor_occupancy") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								id="society_step-13"
								to="/parkingAreaLogs"
								primaryText="Occupancy"
								leftIcon={<ApartmentOutlinedIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/parkingAreaLogs`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to="/parkingAreaLogs">
								<IconButton>
									<ApartmentOutlinedIcon />
								</IconButton>
							</Link>
						))}
					{resources
						.filter(
							(resource) =>
								![
									"parkings",
									"verifyVehicles",
									"parkingInfo",
									"jammuUsers",
									"crmUsers",
									"allParkingsDetails",
									"parkingSlotBookings",
									"exemptedVehicles",
									"currentVehicles",
									"pastVehicles",
									"monthlyPass",
									"monthlyPassLog",
									"monthlyPassPayment",
									"monthlyPassRequest",
									"operator/users",
									"operator/devices",
									"operator/shifts",
									"operator/patrolling",
									"appUpdateUrls",
									"inventory",
									"cardsInventory",
									"deviceWalletsTransactions",
									"deviceWallet",
									"scannedTagsDetails",
									"visitorLogs",
									"rfidsDeletedDetails",
									"siteAudits",
									"parkingLeds",
									"warriorusers",
									"societiesparking",
									"clientsInfo",
									"getParkingTerminals",
									"reports",
									"fasTagApiData",
									"getFastagsStatus",
									"qrTransactions",
									"qrCodes",
									"parkingAreaLogs",
									"currentlyParked",
									"settlements",
									"scheduledReports",
									"valets/bookings",
									"missedVisitors",
									"qrCodeMonthlyPass",
									"invoices/user-permit",
									"invoices/vaahan-api",
									"fastagStatus",
									"getFastagTimeoutLogs",
									"getAggregateFastagTimeoutLogs",
									"bulkPermitsOnboarding",
									"slotsInventory",
									"valet/passes",
									...showResourcesSeparately,
									...showResourcesSeparatelyPermit,
								].includes(resource.name)
						)
						.map((resource) =>
							menuExpanded ? (
								<Tooltip
									title={
										"Status of boom barrier controllers for smooth operations"
									}
									placement="bottom-end">
									<MenuItemLink
										id="society_step-10"
										key={resource.name}
										to={`/${resource.name}`}
										primaryText={
											(resource.options && resource.options.label) ||
											resource.name
										}
										leftIcon={
											new RegExp(`^/${resource.name}`).test(routePath)
												? renderSelectedIcon(resource)
												: renderIcon(resource)
										}
										sidebarIsOpen={menuExpanded}
										className={
											new RegExp(`^/${resource.name}`).test(routePath)
												? "RaMenuItemLink-active"
												: "RaMenuItemLink-default"
										}
									/>
								</Tooltip>
							) : (
								<Link
									key={resource.name}
									to={`/${resource.name}`}
									className={classes.blockContainer}>
									<IconButton>
										{new RegExp(`^/${resource.name}`).test(routePath)
											? renderSelectedIcon(resource)
											: renderIcon(resource)}
									</IconButton>
								</Link>
							)
						)}

					{/* {(sessionStorage.getItem('role') === "admin" || (sessionStorage.getItem('show_vaccine_drive') !== "1" && sessionStorage.getItem('hide_vehicle_database') !== "1")) && (menuExpanded ?
					<MenuItemLink
						to={`/vehicleDatabase`}
						primaryText="Vehicle Database"
						leftIcon={<img src={new RegExp(`^/vehicleDatabase`).test(routePath) ? LogsGreenIcon : LogsDefaultIcon} alt="Logs" />}
						sidebarIsOpen={menuExpanded}
						className={new RegExp(`^/vehicleDatabase`).test(routePath) ? "RaMenuItemLink-active" : "RaMenuItemLink-default"}
					/>
					:
					<Link to={`/vehicleDatabase`}>
						<IconButton><img src={new RegExp(`^/vehicleDatabase`).test(routePath) ? LogsGreenIcon : LogsDefaultIcon} alt="Logs" /></IconButton>
					</Link>
				)} */}
					{sessionStorage.getItem("allow_payment") === "1" &&
						(menuExpanded ? (
							<MenuItemLink
								to={"/payment"}
								primaryText="Payment"
								leftIcon={<PaymentIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/payment`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to={"/payment"}>
								<IconButton>
									<PaymentIcon />
								</IconButton>
							</Link>
						))}

					{/* {(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('show_parking_controllers') === "1") && (menuExpanded ?
					<MenuItemLink
						to={`/controllers`}
						primaryText="Controllers"
						leftIcon={<DisplaySettings style={{ fontSize: "25px" }} />}
						sidebarIsOpen={menuExpanded}
						className={new RegExp(`^/controllers`).test(routePath) ? "RaMenuItemLink-active" : "RaMenuItemLink-default"}
					/>
					:
					<Link to={`/controllers`}>
						<IconButton className={new RegExp(`^/controllers`).test(routePath) ? "RaMenuItemLink-active" : "RaMenuItemLink-default"}><DisplaySettings style={{ fontSize: "25px" }} /></IconButton>
					</Link>
				)} */}
					{sessionStorage.getItem("hide_resources") === "0" &&
						(menuExpanded ? (
							<Tooltip title="Resources" placement="bottom-end">
								<MenuItemLink
									id="society_step-11"
									to="/resources"
									primaryText="Resources"
									leftIcon={<InfoIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										new RegExp(`^/resource`).test(routePath)
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							</Tooltip>
						) : (
							<Link to="/resources">
								<IconButton>
									<InfoIcon />
								</IconButton>
							</Link>
						))
					}
					{sessionStorage.getItem("hide_contact_us") === "0" &&
						(menuExpanded ? (
							<MenuItemLink
								to={"/contactUs"}
								primaryText="Contact Us"
								leftIcon={new RegExp(`^/contactUs`).test(routePath) ? <img src={ContactUsActiveImg} alt="Icon" width={18} height={20} /> : <img src={ContactUsInActiveImg} alt="Icon" width={18} height={20} />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/contactUs`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to={"/contactUs"}>
								<IconButton>
									{new RegExp(`^/contactUs`).test(routePath) ? <img src={ContactUsActiveImg} alt="Icon" width={18} height={20} /> : <img src={ContactUsInActiveImg} alt="Icon" width={18} height={20} />}
								</IconButton>
							</Link>
						))
					}

				</div>
				<div className={classes.menuSection}>
					{
						sessionStorage.getItem("show_tutorial") === "1" && sessionStorage.getItem("role") === "contractor" &&
						sessionStorage.getItem("show_rfid") === "1" && (
							menuExpanded ? (
								<MenuItemLink
									to={routePath}
									onClick={() => {
										dispatch(setSidebarVisibility(true));
										setTimeout(() => {
											tutorialHandler()
										}, 500);
									}}
									primaryText="Tutorial"
									leftIcon={<MenuBookIcon />}
									sidebarIsOpen={menuExpanded}
									className="RaMenuItemLink-default"
								/>
							) : (

								<IconButton onClick={() => {
									dispatch(setSidebarVisibility(true));
									setTimeout(() => {
										tutorialHandler()
									}, 500);
								}}>
									<MenuBookIcon />
								</IconButton>

							)
						)}
					{sessionStorage.getItem("show_profile") === "1" &&
						sessionStorage.getItem("show_filter") === "0" &&
						(menuExpanded ? (
							<MenuItemLink
								to={"/parking/profile"}
								primaryText="Profile"
								leftIcon={<AccountBoxIcon />}
								sidebarIsOpen={menuExpanded}
								className={
									new RegExp(`^/parking/profile`).test(routePath)
										? "RaMenuItemLink-active"
										: "RaMenuItemLink-default"
								}
							/>
						) : (
							<Link to={"/parking/profile"}>
								<IconButton>
									<AccountBoxIcon />
								</IconButton>
							</Link>
						))}
					{sessionStorage.getItem("hide_change_password") === "0" &&
						(menuExpanded ? (
							<Tooltip title="Change Password" placement="bottom-end">
								<MenuItemLink to="/changePassword"
									primaryText="Change Password"
									leftIcon={<LockOutlinedIcon />}
									sidebarIsOpen={menuExpanded}
									className={
										routePath === `/changePassword`
											? "RaMenuItemLink-active"
											: "RaMenuItemLink-default"
									}
								/>
							</Tooltip>
						) : (
							<Link to={"/changePassword"}>
								<IconButton>
									<LockOutlinedIcon />
								</IconButton>
							</Link>
						))}
					{/* {sessionStorage.getItem('create_sub_user') === "1" && (menuExpanded ?
					<MenuItemLink
						to="/createSubUser"
						primaryText="Create User"
						leftIcon={<PersonAddIcon />}
						sidebarIsOpen={menuExpanded}
						className={routePath === `/createSubUser` ? "RaMenuItemLink-active" : "RaMenuItemLink-default"}
					/>
					:
					<Link to={"/createSubUser"}>
						<IconButton><PersonAddIcon /></IconButton>
					</Link>
				)} */}

					<LogoutDialog
						onLogout={() => onLogout()}
						menuExpanded={menuExpanded}
					/>
					<div
						style={{
							display: "grid",
							gridTemplateColumns: menuExpanded ? "1fr 1fr 1fr 1fr" : "100%",
							columnGap: 10,
							rowGap: menuExpanded ? 0 : 10,
							margin: menuExpanded ? 10 : 16,
						}}>
						<div
							style={{
								backgroundColor: "#F5F8FA",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								width: 50,
								height: 40,
								borderRadius: 5,
							}}>
							<a
								href="https://www.linkedin.com/company/parksmarthq/"
								target="_blank"
								rel="noreferrer"
								style={{ marginTop: 6 }}>
								<img src={linkedinPng} width={20} alt="facebook" />
							</a>
						</div>
						<div
							style={{
								backgroundColor: "#F5F8FA",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								width: 50,
								height: 40,
								borderRadius: 5,
							}}>
							<a
								href="https://twitter.com/parksmarthq/"
								target="_blank"
								rel="noreferrer"
								style={{ marginTop: 6 }}>
								<img src={twitterPng} width={20} alt="facebook" />
							</a>
						</div>
						<div
							style={{
								backgroundColor: "#F5F8FA",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								width: 50,
								height: 40,
								borderRadius: 5,
							}}>
							<a
								href="https://www.instagram.com/parksmarthq/"
								target="_blank"
								rel="noreferrer"
								style={{ marginTop: 6 }}>
								<img src={instagramPng} width={20} alt="facebook" />
							</a>
						</div>
						<div
							style={{
								backgroundColor: "#F5F8FA",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								width: 50,
								height: 40,
								borderRadius: 5,
							}}>
							<a
								href="https://www.facebook.com/ParkSmartHQ"
								target="_blank"
								rel="noreferrer"
								style={{ marginTop: 6 }}>
								<img src={facebook} width={20} alt="facebook" />
							</a>
						</div>
					</div>

				</div>
			</div>
		);
	};

	const element = document.getElementById("kiwi-big-iframe-wrapper");
	if (element && sessionStorage.getItem("username")) {
		// console.log("test");
		element.style.display = "none";
	}

	const tutorialHandler = () => {
		setCurrentPathName(["/permitLogs", "/rfidData", "/rfidRequests", "/rfidInventory", "/reports", "/parkingControllers", "/resources"].includes(routePath) ? "/permitLogs" : routePath);
		setIsActive(true);
	};
	const [inputSearch, setInputSearch] = useState('')
	const [usersList, setUsersList] = useState([]);
	const [filteredUsers, setFilteredUsers] = useState(usersList);
	const [showTutorialImage, setShowTutorialImage] = useState(true);
	const handleChange = (event) => {
		const searchText = event.target.value;
		setInputSearch(searchText);

		// Perform the search/filtering based on the input text
		const filteredList = usersList.filter((user) =>
			user.username.toLowerCase().includes(searchText.toLowerCase())
		);

		setFilteredUsers(filteredList);
	};
	const [loading, setLoading] = useState(false);

	const fetchUsersList = () => {
		setLoading(true);
		const params = {
			filter: JSON.stringify({ username: inputSearch }),
			user_id: sessionStorage.getItem("user_id"),
		};
		fetch(`${config.HOST_NAME}/crm/accessibleUsers?username=${inputSearch}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		})
			.then(response => response.json())
			.then(response => {
				setUsersList(response.data)
				setFilteredUsers(response.data)
				setLoading(false);
			})
			.catch(error => {
				notify('Error in fetching Data', 'warning');
				setLoading(false);
			});
	}

	const handleListItemClick = (data) => {
		console.log(data);
		setAvatarAnchorName(null)
		setInputSearch("");
	}

	useEffect(() => {
		let timeoutId;

		const delayedFetch = () => {
			timeoutId = setTimeout(() => {
				fetchUsersList();
			}, 1000);
		};

		delayedFetch();

		return () => {
			clearTimeout(timeoutId);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inputSearch]);



	useEffect(() => {
		resetCustomReduxStates(dispatch);

		var params = {
			user_id: sessionStorage.getItem("user_id"),
			filter: JSON.stringify({ includeSocieties: true }),
		};
		fetch(`${config.HOST_NAME}/crm/v3/parkings?${stringify(params)}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${sessionStorage.getItem("token")}`,
			},
		})
			.then((response) => response.json())
			.then((responseJson) => {
				if (responseJson.success) {
					dispatch({
						type: "UPDATE_PARKINGS",
						payload: {
							parkings: { loading: false, data: responseJson.data },
						},
					});
				} else {
					notify(responseJson.message, "warning");
				}
			})
			.catch((e) => {
				notify("Error fetching Parkings", "warning");
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, notify]);

	useEffect(() => {
		dispatch(setSidebarVisibility(true));
	}, [dispatch]);

	React.useEffect(() => {
		setDrawerVisible(false);
		setSectionLoader(false)
	}, [routePath]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		fetch(`${config.HOST_NAME}/crm/v3/rfidRequests?pendingRequestsCount=true`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${sessionStorage.getItem("token")}`,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				if (json.success) {
					dispatch({
						type: "UPDATE_PERMIT_REQUESTS_COUNT",
						payload: {
							permitRequestsCount: json.data,
						},
					});
				}
			})
			.catch((e) => { });

		if (
			tutorials[routePath] &&
			sessionStorage.getItem("society_onboard_tour") === "0" &&
			sessionStorage.getItem("role") === "contractor" &&
			sessionStorage.getItem("show_rfid") === "1"
		) {
			setDrawerVisible(true)
			setTimeout(() => {
				tutorialHandler()
			}, 1000);
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		// Hide the tutorial after 10 seconds
		const timeoutId = setTimeout(() => {
			setShowTutorialImage(false);
		}, 15000);

		// Clear the timeout when the component is unmounted or when the tutorial is hidden
		return () => clearTimeout(timeoutId);
	}, []); // The empty dependency array ensures that this effect runs only once, equivalent to componentDidMount

	return (
		<ThemeProvider theme={theme}>
			<div className={classes.root}>
				{!isSmallDevice && (
					<Paper
						elevation={0}
						className={classes.sidebar}
						style={{ width: open ? sidebarOpenWidth : sidebarClosedWidth }}
						{...props}>
						<div
							className={classes.sidebarHeader}
							style={{ flexDirection: open ? "row" : "column" }}>
							<div style={{ flex: 1, textAlign: "left" }}>
								<img className={open ? classes.logo : classes.logoSmallDevice} src={open ? PSBLogo : Logo} alt="ParkSmart Business Logo" />
							</div>
							<p
								style={{
									fontSize: open ? 11 : 10,
									color: "#777",
									fontWeight: 400,
									textAlign: "left",
									alignSelf: "center",
									position: "relative",
									marginTop: 0,
									marginBottom: 0,
									top: open ? 0 : -4,
									marginRight: open ? 24 : 0
								}}>
								v{config.CURRENT_DASHBOARD_VERSION}
							</p>

							<Fab
								size="small"
								onClick={toggleSidebar}
								className={classes.toggleFab}>
								<ChevronLeftIcon
									style={{
										transform: open ? `rotate(0deg)` : `rotate(180deg)`,
									}}
								/>
							</Fab>
						</div>
						{renderMenuItems()}
					</Paper>
				)}

				<main
					className={classes.contentWithAppBar}
					style={{
						marginLeft: isSmallDevice
							? 0
							: open
								? sidebarOpenWidth
								: sidebarClosedWidth,
					}}>
					<AppBar
						elevation={0}
						className={classes.appBar}
						open={open}
						style={{
							left: isSmallDevice
								? 0
								: open
									? sidebarOpenWidth
									: sidebarClosedWidth,
							width: isSmallDevice
								? "100%"
								: open
									? `calc(100% - ${sidebarOpenWidth}px)`
									: `calc(100% - ${sidebarClosedWidth}px)`,
							padding: isSmallDevice
								? customTheme.spacing(0, 2, 0, 1)
								: customTheme.spacing(0, 3),
						}}>
						{isSmallDevice && (
							<IconButton
								color="#808080"
								onClick={() => setDrawerVisible(true)}>
								<MenuIcon style={{ marginTop: "6px" }} />
							</IconButton>
						)}
						{RegExp(`^/parkings/[0-9]+/show$`).test(routePath) ? (
							<div
								style={{
									left: isSmallDevice ? 65 : 24,
									color: "#334D6E",
									fontFamily: "Poppins-SemiBold",
									fontSize: 14,
									letterSpacing: "0.01em",
									flex: 1,
								}}> Parkings
							</div>
						) : (
							<SearchBar />
						)}
						{
							<div className="secondaryColor fontWeightSemiBold"
								style={{
									position: "absolute",
									left: isSmallDevice ? 65 : 24,
									fontSize: 14,
									letterSpacing: "0.01em",
								}}>
								{regex.test(routePath)
									? resourceLabel[
									`${routePath.slice(0, routePath.lastIndexOf("/"))}/edit`
									]
									: resourceLabel[routePath]}
							</div>
						}

						{sessionStorage.getItem("role") !== "admin" && <ControllersQuickPanel/>}

						{displayName && displayName !== "" && fullName && fullName !== "" &&
							(isSmallDevice ? (
								<div style={{ color: "#000", textAlign: "right", display: "flex", justifyContent: "center", alignItems: "center", }}>
									<Avatar
										className={classes.avatar}
										onClick={(event) => setAvatarAnchor(event.currentTarget)}>
										{displayName[0]}
									</Avatar>
									{/* {showFilter && showParkingSelectorToResource.includes(location.pathname) && <CustomParkingSelectorPopOver />} */}
								</div>
							) : (

								<div style={{ color: "#000", textAlign: "right", display: "flex", justifyContent: "center", alignItems: "center", }}>
									{sessionStorage.getItem("clicked_user") ?
										<div style={{ display: "flex", alignItems: "center" }}>
											<div>
												<div style={{ fontSize: 17, fontFamily: "Poppins-Medium", color: "#192A3E", fontWeight: 500, }}>
													{sessionStorage.getItem("clicked_user")}
												</div>
												<div style={{ fontSize: 11, fontFamily: "Poppins-Medium", color: "#90A0B7", fontWeight: 100, }}>
													{sessionStorage.getItem("clicked_user")}
												</div>
											</div>
											<div style={{ marginLeft: 10 }}>
												<button style={{ all: "unset", cursor: "pointer" }} onClick={changeToAdminUser}><CancelIcon /></button>
											</div>
										</div>
										:

										<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
											<div>
												<div className="secondaryColor fontWeightBold" style={{ fontSize: 14 }}>
													{displayName}
												</div>
												<div className="fontWeightMedium" style={{ fontSize: 11, color: "#90A0B7" }}>
													{fullName}
												</div>
											</div>
											<div>{sessionStorage.getItem("role") === "admin" && sessionStorage.getItem("allow_client_view") === "1" && <button onClick={(event) => setAvatarAnchorName(event.currentTarget)} style={{ all: "unset", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", marginLeft: 10, padding: 0, backgroundColor: "#F5F8FA", width: 35, height: 35, borderRadius: 5 }}>{avatarAnchorName ? <KeyboardArrowUpIcon style={{ marginBottom: 3, fontWeight: 800 }} /> : <KeyboardArrowDownIcon style={{ marginBottom: 3, fontWeight: 800 }} />}</button>}</div>
											<div>{sessionStorage.getItem("old_user") ? <button onClick={changeToOldUser} style={{ all: "unset", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", marginLeft: 10, padding: 0, backgroundColor: "#FED3CF", width: 35, height: 35, borderRadius: 5 }}><CloseIcon style={{ fontWeight: 800, color: "#F7685B" }} /></button> : <div></div>}</div>
										</div>}
									{/* {showFilter && showParkingSelectorToResource.includes(location.pathname) && <CustomParkingSelectorPopOver />} */}
									{/* {showFilter && <CustomParkingSelectorPopOver />} */}
								</div>
							))}

						{!fullName &&
							(isSmallDevice ? (
								<div style={{ color: "#000", textAlign: "right", display: "flex", justifyContent: "center", alignItems: "center", }}>
									<Avatar
										className={classes.avatar}
										onClick={(event) => setAvatarAnchor(event.currentTarget)}>
										{displayName[0]}
									</Avatar>
									{/* {showFilter && showParkingSelectorToResource.includes(location.pathname) && <CustomParkingSelectorPopOver />} */}
									{/* {showFilter && <CustomParkingSelectorPopOver />} */}
								</div>
							) : (
								<div style={{ color: "#000", textAlign: "right", display: "flex", justifyContent: "center", alignItems: "center" }}>
									<div className="secondaryColor fontWeightBold" style={{ fontSize: 14 }}>
										{displayName ? displayName : userName}
									</div>
									<div>{sessionStorage.getItem("role") === "admin" && sessionStorage.getItem("allow_client_view") === "1" && <button onClick={(event) => setAvatarAnchorName(event.currentTarget)} style={{ all: "unset", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", margin: 10, padding: 0, backgroundColor: "#F5F8FA", width: 35, height: 35, borderRadius: 5 }}>{avatarAnchorName ? <KeyboardArrowUpIcon style={{ marginBottom: 3, fontWeight: 800 }} /> : <KeyboardArrowDownIcon style={{ marginBottom: 3, fontWeight: 800 }} />}</button>}</div>
									<div>{sessionStorage.getItem("old_user") ? <button onClick={changeToOldUser} style={{ all: "unset", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", marginLeft: 10, padding: 0, backgroundColor: "#FED3CF", width: 35, height: 35, borderRadius: 5, }}><CloseIcon style={{ marginTop: 1, fontWeight: 800, color: "#F7685B" }} /></button> : <div></div>}</div>

									{/* {showFilter && showParkingSelectorToResource.includes(location.pathname) && <CustomParkingSelectorPopOver />} */}
									{/* {showFilter && <CustomParkingSelectorPopOver />} */}
								</div>
							))}
					</AppBar>
					<div>
						{sectionLoader && (
							<LinearProgress
								color="primary"
								style={{
									position: "fixed",
									top: 60,
									width: "100%",
									Zindex: 100,
								}}
							/>
						)}

						<div
							className={classes.content}
							style={{
								paddingLeft: customTheme.spacing(3),
								paddingRight: customTheme.spacing(3),
								paddingTop: 0,
							}}>
							{children}
						</div>
					</div>
				</main>
				<Notification />
			</div>

			<Popover
				open={Boolean(avatarAnchor)}
				anchorEl={avatarAnchor}
				onClose={() => setAvatarAnchor(null)}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				style={{ top: 5 }}>
				<div
					style={{
						padding: customTheme.spacing(2),
						display: "flex",
						flexDirection: "column",
					}}>
					<Typography variant="body1" style={{ textTransform: "capitalize" }}>
						{displayName}
					</Typography>
					<Link
						style={{ textDecoration: "none", cursor: "default" }}
						to="/changePassword">
						<Button
							style={{
								color: "#666",
								padding: customTheme.spacing(0.6, 1.2),
								marginTop: 10,
								letterSpacing: 0.4,
								fontSize: 14,
								textTransform: "none",
							}}>
							Change Password
						</Button>
					</Link>
					<Button
						style={{
							color: customTheme.palette.error.main,
							padding: customTheme.spacing(0.6, 1.2),
							alignSelf: "flex-end",
							marginTop: 10,
							letterSpacing: 0.4,
							fontSize: 14,
							textTransform: "none",
						}}
						onClick={onLogout}>
						Logout
					</Button>
				</div>
			</Popover>

			<Popover
				open={Boolean(avatarAnchorName)}
				anchorEl={avatarAnchorName}
				onClose={() => setAvatarAnchorName(null)}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				style={{ top: 5 }}
				PaperProps={{
					style: {
						borderRadius: "15px", // Adjust the value as needed
					},
				}}
			>
				<div style={{ display: "flex", gap: 0 }}>
					<div
						className="customInputFilter"
						style={{
							display: "flex",
							justifyContent: "start",
							alignItems: "center",
							flex: 1,
							columnGap: 10,
							padding: 10,
							margin: 10,
							marginRight: 0,
							marginBottom: 1,
							borderRadius: 5,
							width: "auto",
						}}
					>
						<SearchIcon style={{ fill: "#6a707e", fontSize: 25 }} />
						<input
							className="customInputFilter"
							type="text"
							value={inputSearch}
							onChange={handleChange}
							placeholder={'Search Account'}
							style={{ fontFamily: "Poppins-Medium", fontWeight: 300, width: "auto", fontSize: 14 }}
						/>
					</div>
					<button style={{ all: "unset", cursor: "pointer" }}>
						<div className="customInputFilter"
							style={{
								display: "flex",
								justifyContent: "start",
								alignItems: "center",
								flex: 1,
								columnGap: 10,
								padding: 10,
								margin: 10,
								marginLeft: 0,
								marginBottom: 1,
								borderRadius: 5,
								width: "auto",
								backgroundColor: "#18cc69"
							}}><KeyboardArrowRightIcon style={{ color: "white", fontWeight: "bold" }} /></div></button></div>
				<div
					style={{
						overflowY: 'scroll',  // Enable vertical scrolling
						maxHeight: '220px',  // Adjust the maximum height as needed
						padding: 10,
					}}
				>
					<style>
						{`
			  /* Hide scrollbar while keeping it functional */
			  ::-webkit-scrollbar {
				width: 0.5em;
			  }
		
			  ::-webkit-scrollbar-thumb {
				background-color: #c1c1c1;
			  }
			  
			  /* Add hover effect to the list items */
			  ol li:hover {
				background-color: #f2f2f2;  /* Light grey background color */
			  }
			`}
					</style>
					<ol
						style={{
							listStyleType: "none",
							padding: 10,
							margin: 0,
						}}
					>
						{loading ?
							(<li style={{ textAlign: "center" }}><CircularProgress color="success" /></li>)
							: filteredUsers?.length > 0 ?
								(
									filteredUsers?.slice(0, 10)?.map((data) => (
										<li
											key={data.username}
											style={{
												textAlign: "center",
												cursor: "pointer",
												padding: "7px 0",
												fontFamily: "Poppins-Regular",
												//   padding: "0.5rem 1.5rem 1rem",
												borderRadius: "1.5rem",
												color: "#18cc69",
												margin: "5px",
											}}
											onClick={() => changeUser(data)}
										>
											{data.username} {data.full_name ? "-" : ""} {data.full_name ? data.full_name : ""}
										</li>
									))
								) : (
									<li style={{ textAlign: "center" }}>No user found...</li>)}
					</ol>
				</div>
			</Popover>


			{isSmallDevice && (
				<Drawer
					anchor="left"
					open={drawerVisible}
					onClose={() => setDrawerVisible(false)}>
					{renderMenuItems()}
				</Drawer>
			)}

			<Dialog
				open={sessionTimedout}
				BackdropProps={{
					classes: {
						root: classes.backDrop,
					},
				}}
				classes={{ paper: classes.dialogPaper }}>
				<Typography variant="h6">Session Timeout</Typography>
				<DialogContent style={{ padding: "14px 50px 14px 0px", fontSize: 15 }}>
					You have been logged out due to inactivity
				</DialogContent>
				<DialogActions style={{ paddingRight: 0 }}>
					<Button
						variant="contained"
						onClick={() => {
							onLogout();
							const element = document.getElementById("kiwi-big-iframe-wrapper");
							if (element) {
								element.style.display = "block";
							}
						}}
						color="primary"
						style={{ textTransform: "none" }}>
						Log Back In
					</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>
	);
};

const tempDataControllerStatus = {
	"data": {
		"total": 0,
		"percentage_online": 0,
		"percentage_offline": 0,
		"types": {
			"Connectivity": {
				"Controllers": {
					"total": 0,
					"total_online": 0,
					"total_offline": 0,
				},
				"POS": {
					"total": 0,
					"total_online": 0,
					"total_offline": 0,
				}
			},
			"Hardware": {
				"Reader": {
					"total": 0,
					"total_online": 0,
					"total_offline": 0,
				},
				"Camera": {
					"total": 0,
					"total_online": 0,
					"total_offline": 0,
				}
			}
		}
	}
}

const ControllersQuickPanel = () => {
	const history = useHistory()
	const isSmallDevice = useMediaQuery((theme) => customTheme.breakpoints.down("xs"));
	const [anchorEl, setAnchorEl] = useState(null);
	const [details, setDetails] = useState(tempDataControllerStatus.data);
	const [loading, setLoading] = useState(false);
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	const handleClose = () => {
		setAnchorEl(null);
	};

	const onOpen = (event) => {
		if (details) setAnchorEl(event.currentTarget);
	}

	const redirectHandler = () => {
		handleClose()
		history.push(`/parkingControllers`)
	}

	const fetchDetails = () => {
		setLoading(true)
		var params = {
			user_id: sessionStorage.getItem("user_id"),
		}
		fetch(`${config.HOST_NAME}/crm/controllers/status?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
		})
			.then(response => response.json())
			.then((responseJson) => {
				if (responseJson.success && responseJson.data) setDetails(responseJson.data)
			})
			.catch((e) => {
				// notify('Error fetching data', 'warning');
				console.log(e);
			})
			.finally(() => {
				setLoading(false)
			})
	}

	useEffect(() => {
		fetchDetails()
	}, [])

	return (
		<div style={{ marginRight: 28 }}>
			<div onClick={onOpen} style={{ padding: "0px 8px", display: "flex", justifyContent: "flex-start", alignItems: "center", width: isSmallDevice ? 50 : 250, height: 34, borderRadius: 4, border: "1px solid #DCDCDC" }}>
				{!isSmallDevice && <div style={{ width: "100%", color: "#7C7C7C", fontSize: 12, display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
					<div>Controllers Status</div>
					{anchorEl ? <ExpandMoreIcon style={{ color: "#7C7C7C", fontSize: 18 }} /> : <ChevronRightIcon style={{ color: "#7C7C7C", fontSize: 18 }} />}
				</div>}
				{!loading && details &&
					<div className="horizontal-bar" style={{ width: "100%", height: 12, borderRadius: 4 }}>
						{(details.percentage_online || details.percentage_online) ?
							<>
								<div className="bar-segment" style={{ width: `${details.percentage_online}%`, backgroundColor: "#18CC69" }}></div>
								<div className="bar-segment" style={{ width: `${details.percentage_offline}%`, backgroundColor: "#F74E3D" }}></div>
							</>
							:
							<div className="bar-segment" style={{ width: `100%`, backgroundColor: "#DCDCDC" }}></div>}
					</div>
				}
				{loading && !details && <Skeleton variant="text" width="100%" height={24} />}
			</div>

			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				elevation={1}
			>
				<div style={{ color: "#292929", padding: 16, fontSize: 12, width: 280 }}>
					{details && details.types &&
						<>
							{
								Object.keys(details.types).map((type) => (
									<>
										<div style={{ marginBottom: 14, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
											<div style={{ width: 50, fontSize: 13, fontWeight: 600 }}>{type}</div>
											<div style={{ display: "flex", gap: 5, opacity: type === 'Connectivity' ? 1 : 0 }}>
												<div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: "#188CC6919" }}>
													<div style={{ width: 7, height: 7, borderRadius: 10, backgroundColor: "#18CC69" }} />
												</div>
												<div>
													Online
												</div>
											</div>
											<div style={{ display: "flex", gap: 5, opacity: type === 'Connectivity' ? 1 : 0 }}>
												<div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: "#F74E3D19" }}>
													<div style={{ width: 7, height: 7, borderRadius: 10, backgroundColor: "#F74E3D" }} />
												</div>
												<div>
													Offline
												</div>
											</div>
										</div>
										{Object.keys(details.types[type]).map((subType) => (
											<div style={{ marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
												<div style={{ width: 50 }}>{subType}</div>
												<div>{details.types[type][subType].total_online}/{details.types[type][subType].total}</div>
												<div>{details.types[type][subType].total_offline}/{details.types[type][subType].total}</div>
											</div>
										))}
									</>

								))
							}

							{sessionStorage.getItem('show_parking_controllers') === "1" && <Button
								className='addBorderRadius'
								onClick={() => redirectHandler()}
								color="primary"
								variant="contained"
								style={{ marginTop: 4, textTransform: "none", fontSize: 12, fontFamily: "Poppins-Regular", height: "40px", minWidth: "120px", width: "100%", backgroundColor: "#279AEB19", color: "#279AEB" }}
								disableElevation
							>
								View All
							</Button>
							}
						</>

					}
				</div>
			</Popover >
		</div>
	);
}


export default CustomLayout;


